import Example from './example/Example';
import React from 'react';
import { PageSEO } from '../common/blog/elements/SEO';
import PageLayout from '../common/page-layout/PageLayout';

import example1Image from 'public/Example-1.png';
import example2Image from 'public/Example-2.png';
import example3Image from 'public/Example-3.png';

export default function Examples() {
  return (
    <PageLayout>
      <>
        <PageSEO
          title={'Examples - Limbiks'}
          description={
            'Examples of flashcards generated by Limbiks for different files'
          }
        />{' '}
        <section className="py-16">
          <div className="bg-white">
            <div className="container mx-auto my-2 mb-2 flex max-w-5xl flex-col gap-5 pl-8 pr-8 md:my-8">
              <h1 className="mb-4 mt-16 w-full px-5 text-center text-4xl font-bold leading-tight text-gray-800">
                Examples
              </h1>
              <h1 className="mb-8 w-full px-5 text-center text-lg text-gray-800">
                Below is an assortment of examples that show what Limbiks can
                do. Each example includes a screenshot of the original file, and
                then a few samples of the questions that were generated.
                Download links to the original files are included so you can{' '}
                <span className="font-bold">
                  try uploading these files yourself
                </span>{' '}
                and see Limbiks in action!
              </h1>
              <Example
                title="Example #1 - Hypertension Powerpoint"
                displayImage={example1Image}
                displayImageWidth={430}
                displayImageHeight={246}
                totalQuestions={14}
                previewQuestions={[
                  {
                    question: 'What is a hypertensive crisis?',
                    answer: 'Severely elevated blood pressure'
                  },
                  {
                    question:
                      'What are the two categorizations of a hypertensive crisis?',
                    answer: 'Hypertensive Urgency and Hypertensive Emergency'
                  },
                  {
                    question:
                      'Which organs are most affected by a hypertensive emergency?',
                    answer: 'Brain, kidney, heart and lungs'
                  },
                  {
                    question:
                      'What are some symptoms of a hypertensive crisis?',
                    answer:
                      'Confusion, drowsiness, chest pain and breathlessness'
                  }
                ]}
                downloadLinks={[
                  {
                    fileDescription: 'powerpoint file',
                    url: '/Example-1.pptx'
                  }
                ]}
              />
              <Example
                title="Example #2 - Battles of the American Revolution PDF"
                displayImageWidth={430}
                displayImageHeight={502}
                displayImage={example2Image}
                totalQuestions={34}
                previewQuestions={[
                  {
                    question:
                      'What sparked the beginning of the American Revolution?',
                    answer: 'Battles of Lexington and Concord'
                  },
                  {
                    question: 'When did the American Revolution begin?',
                    answer: 'April 1775'
                  },
                  {
                    question:
                      'Who wanted to gain control of the Charles and Mystic Rivers?',
                    answer: 'British troops'
                  },
                  {
                    question: 'What was the Battle of Trenton?',
                    answer:
                      "Washington's surprise attack on Hessian soldiers in Trenton"
                  },
                  {
                    question:
                      'How many men did General Prescott station on the hill the night before the battle?',
                    answer: '1200 men'
                  }
                ]}
                downloadLinks={[
                  {
                    fileDescription: 'pdf file',
                    url: '/Example-2.pdf'
                  }
                ]}
              />
              <Example
                title="Example #3 - Peregrine Falcon Notes Word Document"
                displayImage={example3Image}
                totalQuestions={7}
                displayImageWidth={430}
                displayImageHeight={299}
                previewQuestions={[
                  {
                    question: 'What is the origin of the Peregrine Falcon?',
                    answer: 'Member of Falconidae family'
                  },
                  {
                    question:
                      'What is the historical name for the Peregrine Falcon in North America?',
                    answer: 'Duck Hawk'
                  },
                  {
                    question: 'Where can Peregrine Falcons be found?',
                    answer:
                      'Everywhere except extreme polar regions, high mountains, and most tropical rainforests'
                  },
                  {
                    question: 'What is the primary diet of Peregrine Falcons?',
                    answer: 'Medium-sized birds'
                  },
                  {
                    question:
                      'What is the maximum recorded speed of a diving Peregrine Falcon?',
                    answer: '242 Miles per hour'
                  }
                ]}
                downloadLinks={[
                  {
                    fileDescription: 'word document',
                    url: '/Example-3.docx'
                  }
                ]}
              />
            </div>
          </div>
        </section>
      </>
    </PageLayout>
  );
}
